import { FilterGroup } from '@vendasta/va-filter2';
import { ColumnType, Pinned, TableDefinition } from '@vendasta/va-filter2-table';
import { UserListActionColumnComponent } from './columns/user-list-action-column.component';
import { UserListDateColumnComponent } from './columns/user-list-date-column.component';
import { UserListNameColumnComponent } from './columns/user-list-name-column.component';
import { UserList } from './user-list';

const USER_LISTS_OVERVIEW_TABLE_DEF: TableDefinition = {
  id: 'user-lists-overview',
  labels: {
    noResults: 'No results',
    cancel: 'Cancel',
    none: 'None',
    update: 'Update',
    sortBy: 'Sort By',
    thenSortBy: 'Then Sort By',
    addAnotherSortColumn: 'Add another column to sort on',
    chooseColumnToSortBy: 'Choose a column to sort on',
    columnSorting: {
      date: {
        ascending: 'Earliest to Latest',
        descending: 'Latest to Earliest',
      },
      number: {
        ascending: '1 to 9',
        descending: '9 to 1',
      },
      string: {
        ascending: 'A to Z',
        descending: 'Z to A',
      },
      default: {
        ascending: 'ascending',
        descending: 'descending',
      },
    },
    export: {
      buttonText: 'Export',
      buttonTooltipAfterCount: '',
      buttonTooltipBeforeCount: '',
    },
  },
  options: {
    selectableRows: false,
  },
  columns: [
    {
      cellComponent: UserListNameColumnComponent,
      id: 'userListName',
      displayName: 'Name',
      field: 'userListName',
      translateCell: false,
      type: ColumnType.COLUMN_TYPE_STRING,
    },
    {
      id: 'numUsers',
      displayName: 'Number of Users',
      field: 'numUsers',
      translateCell: false,
      type: ColumnType.COLUMN_TYPE_NUMBER,
    },
    {
      cellComponent: UserListDateColumnComponent,
      id: 'date',
      displayName: 'Last Modified',
      field: 'lastModified',
      translateCell: false,
      type: ColumnType.COLUMN_TYPE_DATE,
    },
    {
      cellComponent: UserListActionColumnComponent,
      id: 'action',
      displayName: '',
      field: 'action',
      translateCell: false,
      pinned: Pinned.PINNED_RIGHT,
    },
  ],
  rowEqualityFunc: (row1: UserList, row2: UserList) => row1.userListName === row2.userListName,
};

export const tableDefinitionFactory = () => {
  const tableDefinition = USER_LISTS_OVERVIEW_TABLE_DEF;
  tableDefinition.filters = new FilterGroup('user-lists-overview');
  return tableDefinition;
};
